import { Routes } from '@angular/router';
import { authGuard } from './guards/auth.guard';

export const routes: Routes = [
  {
    path: '',
    canActivate: [authGuard],
    loadComponent: () => import('./components/tasks-by-rule/tasks-by-rule.component').then(m => m.TasksByRuleComponent)
  }
];
